import { Provider } from 'models';
import React from 'react';
import BioDetail from '../details/BioDetail';
import JobTypesDetail from '../details/JobTypesDetail';

const InternalProviderCardDetails = ({ provider }: { provider: Provider }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', marginTop: 12 }}>
            <JobTypesDetail provider={provider} />
            <div style={{ marginBottom: 12 }} />
            <BioDetail bio={provider.bio} />
        </div>
    );
};

export default InternalProviderCardDetails;
